import { isTimingOverlayStatus, normalizeWorkflowStatusKey } from './operationalStatusConfig';

const MANUAL_TRANSITION_BLOCKED_STATUS_KEYS = new Set([
  'dispatched',
  'en_route',
  'on_route',
  'arrived',
  'on_site',
  'checked_in',
  'working',
  'ai_review',
  'ai_on_hold',
  'admin_reopened',
]);

export function isSystemManagedWorkflowStatusKey(statusKey?: string | null): boolean {
  if (!statusKey) {
    return false;
  }

  const normalized = normalizeWorkflowStatusKey(statusKey);

  // Timing overlay statuses (running_late, over_schedule) are not real workflow
  // statuses and must never be manually targeted or used as transition endpoints.
  if (isTimingOverlayStatus(normalized)) {
    return true;
  }

  return MANUAL_TRANSITION_BLOCKED_STATUS_KEYS.has(normalized);
}

export function canManuallyTargetWorkflowStatusKey(statusKey?: string | null): boolean {
  return !isSystemManagedWorkflowStatusKey(statusKey);
}

export function getManualTransitionBlockedStatusKeys(): string[] {
  return Array.from(MANUAL_TRANSITION_BLOCKED_STATUS_KEYS);
}
